export const PAYWALL_GUIDED_ANCHOR_EXPERIMENT_KEY = "paywall_guided_anchor_v1";

export const PAYWALL_GUIDED_ANCHOR_VARIANTS = {
  control: "control",
  guidedAnchor: "guided_anchor_v1",
} as const;

export const PAYWALL_CONTROL_PLAN_ORDER = ["weekly", "monthly", "annual"] as const;

export type PaywallGuidedAnchorVariant =
  (typeof PAYWALL_GUIDED_ANCHOR_VARIANTS)[keyof typeof PAYWALL_GUIDED_ANCHOR_VARIANTS];

export const PAYWALL_GUIDED_ANCHOR_LAYOUTS: Record<PaywallGuidedAnchorVariant, string> = {
  [PAYWALL_GUIDED_ANCHOR_VARIANTS.control]: "three_plan_graphite_v1",
  [PAYWALL_GUIDED_ANCHOR_VARIANTS.guidedAnchor]: "guided_anchor_v1",
};

export function parsePaywallGuidedAnchorVariant(
  value: boolean | string | undefined
): PaywallGuidedAnchorVariant | null {
  if (value === PAYWALL_GUIDED_ANCHOR_VARIANTS.control) {
    return PAYWALL_GUIDED_ANCHOR_VARIANTS.control;
  }

  if (value === PAYWALL_GUIDED_ANCHOR_VARIANTS.guidedAnchor) {
    return PAYWALL_GUIDED_ANCHOR_VARIANTS.guidedAnchor;
  }

  return null;
}
